<template>
  <div class="p-10">
    <div v-html="content" />
  </div>
</template>

<script>
import { getByCode } from "@/api/ik/data/dataApi"

export default {
  name: "ShowContent",
  props: {
    rowCode: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      content: "",
      bgPath: "health.content.label.contentinfo"
    }
  },
  watch: {
    rowCode: {
      immediate: true,
      handler() {
        this.getByCode()
      }
    },
    field: {
      immediate: true,
      handler() {
        this.getByCode()
      }
    }
  },
  methods: {
    getByCode() {
      console.log("rowCode", this.rowCode)
      if (!this.rowCode || !this.field) {
        this.content = this.row[this.field]
      } else {
        const bgPath = this.bgPath.split(".").join("/")
        getByCode(bgPath, this.rowCode).then(res => {
          this.content = res.data.head[this.field] || ""
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
